import React, { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "./style.css";

const roundCoord = (value) => Math.round(value * 1e6) / 1e6;

const MapUpdater = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    if (lat && lng) {
      const timer = setTimeout(() => {
        map.invalidateSize();
        map.setView([parseFloat(lat), parseFloat(lng)], 15);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [lat, lng, map]);

  return null;
};

const SearchControl = ({ onLocationSelect }) => {
  const map = useMap();

  useEffect(() => {
    const searchControl = new GeoSearchControl({
      provider: new OpenStreetMapProvider(),
      style: "bar",
      autoClose: true,
      keepResult: true,
      showMarker: false,
      searchLabel: "Search for a location",
    });

    map.addControl(searchControl);

    const handleShowLocation = (event) => {
      onLocationSelect?.({
        latitude: roundCoord(event.location.y),
        longitude: roundCoord(event.location.x),
      });
    };

    map.on("geosearch/showlocation", handleShowLocation);

    return () => {
      map.off("geosearch/showlocation", handleShowLocation);
      map.removeControl(searchControl);
    };
  }, [map, onLocationSelect]);

  return null;
};

const ClickHandler = ({ onLocationSelect }) => {
  useMapEvents({
    click: (event) => {
      onLocationSelect?.({
        latitude: roundCoord(event.latlng.lat),
        longitude: roundCoord(event.latlng.lng),
      });
    },
  });

  return null;
};

L.Marker.prototype.options.icon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function LocationMap({
  latitude,
  longitude,
  label,
  onLocationSelect,
}) {
  return (
    <div className="location-picker__map">
      <MapContainer
        center={[latitude ?? 18.1096, longitude ?? -77.2975]}
        zoom={6}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <MapUpdater lat={latitude} lng={longitude} />
        <SearchControl onLocationSelect={onLocationSelect} />
        <ClickHandler onLocationSelect={onLocationSelect} />
        {latitude && longitude && (
          <Marker position={[latitude, longitude]}>
            <Popup>
              <strong>{label || "Selected Location"}</strong>
            </Popup>
          </Marker>
        )}
      </MapContainer>
    </div>
  );
}
